<template>
    <div class="weather-slider" v-bind:class="{unfolded: unfolded}">
        <div class="header" v-on:click="Toggle()">
            <div class="label">16 Tage Wettervorhersage</div>
        </div>
        <div class="weather-slot" v-for="(slot, index) in weather.data" :key="index" v-on:click="OpenPopup($event, slot, index)" v-bind:class="{'week-end': date.clone().add(index, 'days').weekday() === 0,'week-start': date.clone().add(index, 'days').weekday() === 1}">
            <img class="picture"  v-bind:src="'img/'+slot.dWeatherCode+'.svg'"/>
            <div class="label">{{isNaN(slot.dTemp) ? slot.temp : slot.dTemp}}°</div>
        </div>
        <div class="close" v-on:click="Fold()">
            <div class="fa-stack cancel" v-on:click="Fold()">
                <i class="fas fa-circle fa-stack-2x"></i>
                <i class="fas fa-times fa-stack-2x"></i>
            </div>
        </div>
        <weatherpopup ref="popup"/>
    </div>
</template>

<script>
    import weatherpopup from './WeatherPopup.vue'
    import incomepopup from './IncomePopup.vue'
    export default {
        name: "weatherslider",
        components: {
            weatherpopup,
            incomepopup
        },

        created(){
        },
        mounted() {
            let view = this;
            if(view.$store.state.loggedIn){
                view.GetWeather();
            }
            this.$store.watch(this.$store.getters.getLoggedIn, loggedIn => {
                
                if (loggedIn) {
                    view.GetWeather();
                }

            }) 
            
        },
        destroyed () {
        },
        beforeDestroy(){
            if(this.$refs.popup && this.$refs.popup.$el) $(this.$refs.popup.$el).remove();
        },
        updated () {
            $(this.$el).css('transform', 'translateX(-' + ($(this.$el).find('.week-start').length + 4) + 'px)');
        },
        data(){
            return{
                unfolded: true,
                date: moment(),
              weather: {
                  data:[],
              },
              rawData: [],
            }

        },
        methods: {

            GetWeather(){
                var view = this;
                view.rawData = [];
                view.weather.data = [];
                let url = '/api/sec/weather';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/weather');

                this.axios({
                    method: 'get',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                }).then(response => {
                    for(var x in response.data){
                                (function(data){
                                    view.rawData.push(data);
                                    var last = view.rawData[view.rawData.length - 1];
                                    last.date = moment.unix(data.dt).locale('de');

                                    // 3HOURLY DATA - START
                                    last.temp = Math.round(data.temp - 273.15);
                                    last.tempMin = Math.round(data.tempMin - 273.15);
                                    last.tempMax = Math.round(data.tempMax - 273.15);
                                    last.humidity = data.humidity;
                                    last.windspeed = data.windspeed;
                                    //last.pop = data.pop; //The 3hourly weather API does not return the Prob of Precipitation. But it returns the rain in millimeters. We need a workaround to calculate some kind of percentage from the mm information.
                                    last.weatherCode = view.GetWeatherCode(data.weatherId);
                                    // 3HOURLY DATA - END


                                    // DAY DATA - START
                                    last.dTemp = Math.round(data.dTemp - 273.15);
                                    last.dMinTemp = Math.round(data.dMinTemp - 273.15);
                                    last.dMaxTemp = Math.round(data.dMaxTemp - 273.15);
                                    last.dPop = data.dProbOfPrecipitation;
                                    last.dHumidity = data.dHumidity;
                                    last.dWindSpd = Math.round(data.dWindSpd * 3.6);
                                    last.dWeatherCode = view.GetWeatherCode(data.dWeatherCode);
                                    // DAY DATA - END

                                    if(last.date.date() >= moment().date() && !view.weather.data.find(d => d.date.date() === last.date.date()))
                                    {
                                        var hasDTemp = view.rawData.find(d => d.date.date() == last.date.date() && d.dTemp);
                                        if(hasDTemp) view.weather.data.push(hasDTemp);
                                        else view.weather.data.push(last);
                                    }
                                    //console.log(last.date.format('LLLL'));
                                    })(response.data[x]);

                    }
                }).catch(function (error) {
                    //TODO error handling
                })
            },

            GetWeatherCode(id){
                                switch (id){
                                    case 201: // thunderstorm with rain
                                    case 202: // thunderstorm with heavy rain
                                    case 211: // thunderstorm
                                    case 212: // heavy thunderstorm
                                    case 221: // ragged thunderstorm
                                    case 230: // thunderstorm with light drizzle
                                    case 231: // thunderstorm with drizzle
                                    case 232: // thunderstorm with heavy drizzle
                                    case 233: // thunderstorm with hail
                                        return "Thunderstorm_Rain";
                                        break;
                                    case 200: // thunderstorm with light rain
                                    case 210: // light thunderstorm
                                        return "Thunderstorm";
                                        break;


                                    case 300: // light intensity drizzle
                                    case 301: // drizzle
                                    case 302: // heavy intensity drizzle
                                    case 310: // light intensity drizzle rain
                                    case 311: // drizzle rain
                                    case 312: // heavy intensity drizzle rain
                                    case 313: // shower rain and drizzle
                                    case 314: // heavy shower rain and drizzle
                                    case 321: // shower drizzle
                                    case 520: // light intensity shower rain
                                    case 521: // shower rain
                                    case 522: // heavy intensity shower rain
                                    case 531: // ragged shower rain
                                        return "Rain_Medium";
                                        break;

                                    case 500: // light rain
                                    case 501: // moderate rain
                                    case 502: // heavy intensity rain
                                    case 503: // very heavy rain
                                    case 504: // extreme rain
                                        return "Sun_Rain";
                                        break;

                                    case 511: // freezing rain
                                        return "Snow_Rain";
                                        break;
                                    case 600: // light snow
                                    case 601: // Snow
                                    case 602: // Heavy snow
                                    case 610: // Mix snow/rain
                                    case 611: // Sleet
                                    case 612: // Light shower sleet
                                    case 613: // Shower sleet
                                    case 615: // Light rain and snow
                                    case 616: // Rain and snow
                                    case 620: // Light shower snow
                                    case 621: // Shower snow
                                    case 622: // Heavy shower snow
                                    case 623: // Flurries
                                        return "Snow_Medium";
                                        break;

                                    case 700: // mist
                                    case 701: // mist
                                    case 711: // Smoke
                                    case 721: // Haze
                                    case 731: // sand/ dust whirls
                                    case 741: // fog
                                    case 751: // sand
                                    case 761: // dust
                                    case 762: // volcanic ash
                                    case 771: // squalls
                                    case 781: // tornado
                                        return "Fog";
                                        break;
                                    case 800: // clear sky
                                        return "Sunny";
                                        break;
                                    case 801: // few clouds: 11-25%
                                        return "Little_Cloudy";
                                    case 802: // scattered clouds: 25-50%
                                        return "Cloudy_Medium";
                                    case 803: // broken clouds: 51-84%
                                    case 804: // overcast clouds: 85-100%
                                        return "Very_Cloudy";
                                        break;
                                    case 900: // Unknown Precipitation
                                        return "Warnung";
                                        break;
                                    default:
                                        return "Sunny";
                                            break;
                                }
            },
            OpenPopup($event, day, index){
                this.$refs.popup.Init({
                    date: moment().add(index, 'days'),
                    data: this.rawData.slice(),
                    elRelative: $event.currentTarget,
                });
            },
            Toggle(){
                this.unfolded = !this.unfolded;
            },
            Fold(){
                this.unfolded = false
            },
        },
        props:{
        }
    }
</script>

<style scoped>
.weather-slider{

    margin-top: 5px;
    position: absolute;
    height: 30px;
    z-index: 2;
    top: 0;
    left: 0;
    overflow: hidden;
    transform: translateX(-5px);
}

.weather-slider.unfolded{

}
.weather-slider > *{

float: left;

}
.header{

    width: 220px;
    height: 100%;
    background: #c1c1c1;
    border-top-left-radius: 100px;
    border-bottom-left-radius: 100px;
    display: inline-block;
    height: 30px;
    cursor: pointer;
    display: none;
}

.weather-slot{
    white-space: pre;
    width: 50px;
    display: inline-block;
    background: none;
    transition: .2s;
    box-shadow: inset -2px 0 0 -1px #cccccc;
    overflow: hidden;
    height: 30px;
}


.weather-slot .picture{
    width: 15px;
    margin-top: 5px;
    margin-left: 5px;
    height: 15px;
    display: inline-block;
    pointer-events: none;
    float: left;
}

.weather-slot .label{
    font-family: DistrictProLight;
    pointer-events: none;
    font-weight: 200;
}

.weather-slot{
    width: 0;
    pointer-events: none;
}

.unfolded .weather-slot{
    width: 50px;
    cursor: pointer;
    pointer-events: initial;
}
 .weather-slot.week-end{
     width: 50px;
     box-shadow: inset -2px 0 0 -1px #808080;
 }

 .weather-slot.week-start{
     width: 51px;
 }

 .weather-slot:nth-child(2){
     box-shadow: inset -2px 0 0 -1px #cccccc, inset 2px 0 0 -1px #cccccc;
        width: 51px;
 }
 .weather-slot.week-start:nth-child(2){
     width: 52px;
 }
 .weather-slot.week-end:nth-child(2){
     width: 51px;
     box-shadow: inset -2px 0 0 -1px #808080, inset 2px 0 0 -1px #cccccc;
 }

 .weather-slot.week-start:nth-child(2){
     box-shadow: inset -2px 0 0 -1px #cccccc, inset 2px 0 0 -1px #808080;
 }

.header .label{
    color: white;
    font-size: 14px;
    padding-top: 3px;
    padding-left: 8px;
    /* font-family: DistrictProLight; */
    width: 100%;
    font-weight: 600;
    text-align: center;
    letter-spacing: 1.5px;
    white-space: pre;
    pointer-events: none;
}

.close{
    background: #c1c1c1;
    border-top-right-radius: 100px;
    border-bottom-right-radius: 100px;
    display: inline-block;
    display: none;
    font-size: 12px;
    opacity: 1!important;
    text-shadow: none;
    cursor: pointer;
    height: 30px;
}

.close .fa-stack{
    transform: translateY(3px) scale(.7);
    cursor: pointer;

}
.close .fa-times{
    pointer-events: none;
    color: #c1c1c1;
    transform: scale(.7);
}

.close .fa-circle{
    pointer-events: none;
    color: white;
}



</style>